import {
	type Sources,
	type StreamAnswerPart,
	type StreamError,
	type StreamFollowUp,
	type StreamResponse,
} from '@atlassian/conversation-assistant-service-api/types/assistance-service';

interface StreamTraceSearchState {
	type: 'TRACE';
	message: {
		message_template: 'CONTENT_SEARCH';
		formulated_query: string;
	};
	millisOffset: number;
	metadata?: {
		request_id: string;
	};
}

interface StreamTraceAnalyzeState {
	type: 'TRACE';
	message: {
		message_template: 'ANALYSING_STATE';
		sources: Sources;
	};
	millisOffset: number;
	metadata?: {
		request_id: string;
	};
}

export type UHStreamMessage =
	| StreamTraceAnalyzeState
	| StreamTraceSearchState
	| StreamResponse
	| StreamAnswerPart
	| StreamError
	| StreamFollowUp;

export const isUHTraceContentSearch = (
	message: UHStreamMessage,
): message is StreamTraceSearchState =>
	message.type === 'TRACE' && message.message.message_template === 'CONTENT_SEARCH';

export const isUHTraceAnalyzingState = (
	message: UHStreamMessage,
): message is StreamTraceAnalyzeState =>
	message.type === 'TRACE' && message.message.message_template === 'ANALYSING_STATE';
